import { Box } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';

// Components
import NavBar from '../navbar/navbar';
import Footer from '../footer/footer';

const Layout = () => {
    return (
        <>
            <NavBar />
            <Box 
                minH="calc(100vh - 400px)" // 400px footer
            >
                <Outlet />
            </Box>
            <Footer />
        </>
    );
};

export default Layout; 